import { Game } from './game/components/Game';

function App() {
  return (
    <div style={{
      minHeight: '100vh',
      padding: '4em',
    }}>
      <Game />
    </div>
  );
}

export default App;
